/* eslint-disable @typescript-eslint/ban-types */
import { BehaviorMappings, NotificationMappings } from "../../models/dispatcher/mappings.js";
/**
 * The internal dispatcher
 * Here storing the mapping between the event name with the handler name
 *
 * @export
 * @class Dispatcher
 * @implements {IDispatcher}
 */
var Dispatcher = /** @class */ (function () {
    function Dispatcher() {
        this._notifications = new NotificationMappings();
        this._behaviors = new BehaviorMappings();
    }
    Object.defineProperty(Dispatcher.prototype, "notifications", {
        get: function () {
            return this._notifications;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Dispatcher.prototype, "behaviors", {
        get: function () {
            return this._behaviors;
        },
        enumerable: false,
        configurable: true
    });
    return Dispatcher;
}());
export default Dispatcher;
//# sourceMappingURL=index.js.map